// network error messages from Chrome, Safari and Firefox,
// to which Sentry's fetch instrumentation appends the request host: "Failed to fetch (example.com)"
const FETCH_ERROR_MESSAGES = ['Failed to fetch', 'Load failed', 'NetworkError when attempting to fetch resource.'];

// ad & analytics hosts blocked by ad blockers, and hosts used by adware extensions
const BLOCKED_THIRD_PARTY_DOMAINS = [
	'doubleclick.net',
	'googlesyndication.com',
	'google-analytics.com',
	'analytics.google.com',
	'facebook.net',
	'safesearchinc.com',
	'killadsapi.com',
	'selnor.fun',
];

function escapeRegExp(value: string): string {
	return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * matches fetch errors for requests to these domains or their subdomains
 */
export function genFetchErrorsPattern(domains: readonly string[]): RegExp {
	const messages = FETCH_ERROR_MESSAGES.map(escapeRegExp).join('|');
	const hosts = domains.map(escapeRegExp).join('|');
	return new RegExp(`(?:${messages}) \\((?:[\\w-]+\\.)*(?:${hosts})(?::\\d+)?\\)`);
}

export const THIRD_PARTY_FETCH_ERRORS_PATTERN = genFetchErrorsPattern(BLOCKED_THIRD_PARTY_DOMAINS);
